<template>
    <div class="select-btn">
        <a
            v-if="!readonly"
            class="label"
        >
            {{typeLabelText}}
        </a>

        <a
            v-else
            ref="trigger1"
            class="label-btn"
        >
            {{typeLabelText}}

            <or-icon
                v-if="readonly"
                icon="arrow_drop_down"
            />

            <or-popover
                class="custom-popover"
                trigger="trigger1"
            >
                <or-menu
                    :options="selectType"
                    @select="selectHandler"
                ></or-menu>
            </or-popover>
        </a>
    </div>
 </template>

<script >
export default {
  props: {
    type: {
      type: String,
      default: 'TEXT'
    },

    readonly: Boolean
  },

  computed: {
    localType: {
      get () {
        return this.type
      },
      set (value) {
        this.$emit('type-changed', value)
      }
    },

    typeLabelText () {
      return this.type === 'JSON'
        ? this.type
        : _.upperFirst(_.toLower(this.type))
    }
  },

  data () {
    return {
      selectType: [
        { label: this.$t('generic.text'), value: 'TEXT' },
        { label: this.$t('generic.flow'), value: 'FLOW' },
        { label: this.$t('generic.json'), value: 'JSON' }
      ]
    }
  },

  methods: {
    selectHandler (value) {
      this.localType = value.value
      this.$refs.trigger1.click()
    }
  }
}
</script>

<style lang="scss" scoped>
    .intent-type {
        width: 96px;
        margin-bottom: 0;
    }

    .select-btn {
        display: flex;
        align-items: center;
        height: 24px;

        .label {
            font-size: 12px;
            font-weight: 600;
            color: $or-black-blue;
        }

        .label-btn {
            display: flex;
            align-items: center;
            font-size: 12px;
            font-weight: 600;
            color: $or-black-blue;

            &:hover {
                cursor: pointer;
            }

            .material-icons {
                font-size: 20px;
            }
        }
    }
</style>
